import { DictionaryDto, DictionaryValueDto } from '@services/src/models';
import { Select } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';
interface IProps {
	name: string;
	dictionary: DictionaryDto | undefined;
	onChange?: (items: number[]) => void;
	selectedValue?: number[];
	mode: mode;
	className?: string;
	disabled?: boolean;
	maxTagCount?: number | undefined;
}

export type mode = 'multiple' | 'tags' | undefined;

const DictionaryFilter = (props: IProps) => {
	return (
		<div id={props.name} className={props.className}>
			{props.name}
			<Select
				mode={props.mode}
				size="small"
				placeholder="Click here to filter"
				onChange={props.onChange}
				value={props.selectedValue}
				disabled={props.disabled}
				maxTagCount={props.maxTagCount}
			>
				{props.dictionary?.values?.map((item: DictionaryValueDto) => {
					return (
						<Select.Option key={item.id} value={item.id!}>
							{item.value}
						</Select.Option>
					);
				})}
			</Select>
		</div>
	);
};

export default observer(DictionaryFilter);
